module.exports = __webpack_public_path__ + "static/media/copy-to-clipboard.4b96c1ef.svg";